"use client";
import useSWR from "swr";
import axios from "axios";

const API = process.env.NEXT_PUBLIC_API_BASE_URL;
const fetcher = (url: string) => axios.get(url).then((r) => r.data);

export interface HomepageArticle {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  coverImageUrl: string | null;
  coverImageAlt: string | null;
  categories: string[];
  pathway: string | null;
  readingTime: number;
  articleType: string | null;
  viewCount: number;
  likeCount: number;
  publishedAt: string | null;
  addedByAdmin?: { id: string; email: string } | null;
  mentorProfile?: { id: string; displayName: string | null } | null;
}

export interface CategoryMeta {
  key: string;
  displayName: string;
  description: string;
  urlSlug: string;
  count: number;
}

export interface BlogHomepageData {
  startHereArticles: HomepageArticle[];
  popularGuides: HomepageArticle[];
  categories: CategoryMeta[];
}

export function useBlogHomepage() {
  const { data, isLoading, error } = useSWR<BlogHomepageData>(
    `${API}/articles/homepage`,
    fetcher,
    { revalidateOnFocus: false, dedupingInterval: 60000 },
  );
  return { data, loading: isLoading, error };
}
